import { EDiagnosticAction, DiagnosticAction } from "../actions/DiagnosticActions";
import { ModuleDiagnosticInfo } from "../../Model/Diagnostic";
import { RootState } from "./RootReducer";
import { Collection } from "../../Model/Collection";

interface State {
  moduleDiagnosticCollection: Collection<ModuleDiagnosticInfo>;
}

const initialState: State = {
  moduleDiagnosticCollection: {
    allIds: [],
    byId: {},
  },
};

function updateDiagnosticCollection(
  diagnosticCollection: Collection<ModuleDiagnosticInfo>,
  diagnosticInfo: ModuleDiagnosticInfo
): Collection<ModuleDiagnosticInfo> {
  const newDiagnosticCollection = {
    allIds: [...diagnosticCollection.allIds],
    byId: { ...diagnosticCollection.byId },
  };

  const isIdentifierExist = newDiagnosticCollection.allIds.indexOf(diagnosticInfo.identifier) !== -1;

  if (!isIdentifierExist) {
    newDiagnosticCollection.allIds.push(diagnosticInfo.identifier);
  }
  newDiagnosticCollection.byId[diagnosticInfo.identifier] = diagnosticInfo;

  return newDiagnosticCollection;
}

export function diagnosticReducer(state = initialState, action: DiagnosticAction): State {
  switch (action.type) {
    case EDiagnosticAction.UPDATE_DIAGNOSTIC:
      return {
        ...state,
        moduleDiagnosticCollection: updateDiagnosticCollection(
          state.moduleDiagnosticCollection,
          action.moduleDiagnosticInfo
        ),
      };

    default:
      return state;
  }
}

export const getModuleDiagnostic = (state: RootState, moduleIdentifier: string): ModuleDiagnosticInfo =>
  state.diagnosticStore.moduleDiagnosticCollection.byId[moduleIdentifier];

export const getDiagnosticCollection = (state: RootState) => state.diagnosticStore.moduleDiagnosticCollection;
